import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Lightning, CircleNotch } from '@phosphor-icons/react';

export default function StakingPanel({
    stakingTiers, stakingPositions, stakeTier, setStakeTier,
    stakeAmount, setStakeAmount, staking, stakeBoltz,
    unstaking, unstakeBoltz, user,
}) {
    return (
        <Card className="glass-card mb-6 border-hot-pink/20">
            <CardHeader>
                <CardTitle className="flex items-center gap-2 text-hot-pink"><Lightning size={20} weight="fill" />Stake Boltz
                    <span className="ml-2 text-[10px] px-2 py-0.5 rounded-full border border-boltz-gold/50 text-boltz-gold" data-testid="staking-demo-badge">DEMO</span>
                </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
                <p className="text-sm text-muted-foreground">Lock your Boltz coins to earn bonus rewards. Longer locks = higher APY.</p>
                <p className="text-xs text-boltz-gold">Demo feature: the BOLTZ token is not minted yet. Staking runs on in-app balances only and APY figures are illustrative, not a financial return.</p>
                <div className="grid grid-cols-3 gap-2">
                    {stakingTiers.map(tier => (
                        <button key={tier.id} onClick={() => setStakeTier(tier.id)}
                            className={`p-3 rounded-xl text-center border transition-all ${stakeTier === tier.id ? 'border-hot-pink bg-hot-pink/10 text-hot-pink' : 'border-white/10 bg-white/5 text-muted-foreground hover:border-white/20'}`}
                            data-testid={`stake-tier-${tier.id}`}>
                            <p className="font-bold text-sm font-display">{tier.label}</p>
                            <p className="text-lg font-black font-mono">{tier.apy}%</p>
                            <p className="text-[10px]">APY</p>
                        </button>
                    ))}
                </div>
                <div className="flex gap-3">
                    <div className="flex-1">
                        <Input type="number" step="1" min={stakingTiers.find(t => t.id === stakeTier)?.min_amount || 10}
                            max={user?.boltz_balance || 0} value={stakeAmount} onChange={(e) => setStakeAmount(e.target.value)}
                            placeholder={`Min ${stakingTiers.find(t => t.id === stakeTier)?.min_amount || 10} Boltz`}
                            className="font-mono" data-testid="stake-amount-input" />
                    </div>
                    <Button onClick={stakeBoltz} disabled={staking || !stakeAmount}
                        className="bg-hot-pink hover:bg-hot-pink/80 text-white font-display" data-testid="stake-btn">
                        {staking ? <CircleNotch size={18} className="animate-spin" /> : 'Stake'}
                    </Button>
                </div>
                {stakingPositions.length > 0 && (
                    <div className="space-y-2 pt-2 border-t border-white/5">
                        <p className="text-xs font-display tracking-wider text-muted-foreground">ACTIVE STAKES</p>
                        {stakingPositions.filter(p => p.status === 'active').map(pos => (
                            <div key={pos.stake_id} className="flex items-center justify-between p-3 rounded-lg bg-white/5 border border-white/5">
                                <div>
                                    <p className="text-sm font-bold font-mono">{pos.amount} Boltz</p>
                                    <p className="text-[10px] text-muted-foreground">
                                        {pos.apy}% APY | Earned: <span className="text-neon-green">{pos.earned_so_far} Boltz</span>
                                        {pos.is_unlocked ? ' | Ready' : ` | Unlocks ${new Date(pos.unlock_at).toLocaleDateString()}`}
                                    </p>
                                </div>
                                <Button size="sm" variant={pos.is_unlocked ? "default" : "outline"}
                                    onClick={() => unstakeBoltz(pos.stake_id)} disabled={unstaking === pos.stake_id}
                                    className={pos.is_unlocked ? "bg-neon-green text-black text-xs" : "text-xs border-white/10"}
                                    data-testid={`unstake-${pos.stake_id}`}>
                                    {unstaking === pos.stake_id ? '...' : pos.is_unlocked ? 'Collect' : 'Early Exit'}
                                </Button>
                            </div>
                        ))}
                    </div>
                )}
            </CardContent>
        </Card>
    );
}
